import { InfoComp } from 'components/InfoComp';
import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { StatusTag } from 'components/tag/StatusTag';
import { Typography } from 'enable-ui';

import { ReactComponent as Rank1Icon } from 'assets/icons/rank1.svg';
import { ReactComponent as Rank2Icon } from 'assets/icons/rank2.svg';
import { ReactComponent as Rank3Icon } from 'assets/icons/rank3.svg';
import { ReactComponent as ThumbUpIcon } from 'assets/icons/thumb-up.svg';

import { isEmpty } from 'lodash';

export const getFullTimeColumns = (
  isBiologicAdmin: boolean,
  onClickAction: (key: 'edit' | 'delete' | 'update-status', id: string) => void,
  institutionValue: string,
) => {
  const columns: any = [
    {
      id: 'name',
      Header: 'Name',
      width: '50%',
      minWidth: '50%',
      sort: true,
      sortType: 'name',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name || '';

        const avatar = props.data[props.row.index]?.physicalProfile?.avatar || '';

        return <InfoComp name={name} avatar={avatar} />;
      },
    },
  ];

  if (isBiologicAdmin && isEmpty(institutionValue)) {
    columns.push({
      id: 'institution',
      Header: 'Institution',
      width: '50%',
      minWidth: '50%',
      sort: true,
      sortType: 'institution',
      Cell: ({ ...props }) => {
        const institution = props.data[props.row.index]?.institution?.name || '';

        return <Typography>{institution}</Typography>;
      },
    });
  }

  // if (checkRole([RoleKey.INSTITUTION_ADMIN])) {
  //   columns.push({
  //     id: 'email',
  //     Header: 'Email',
  //     width: '50%',
  //     minWidth: '50%',
  //     sort: true,
  //     sortType: 'email',
  //     Cell: ({ ...props }) => {
  //       const email = props.data[props.row.index]?.email || '';

  //       return <Typography>{email}</Typography>;
  //     },
  //   });
  // }

  columns.push(
    {
      id: 'level',
      Header: 'Level',
      width: '200px',
      minWidth: '200px',
      sort: true,
      sortType: 'level',
      Cell: ({ ...props }) => {
        const level = props.data[props.row.index]?.trainerRole?.name || '';

        return <Typography>{level}</Typography>;
      },
    },
    {
      id: 'position',
      Header: (
        <div
          style={{
            textAlign: 'center',
            width: 116,
            fontSize: 16,
            lineHeight: '22px',
            color: '#808080',
          }}
        >
          Position
        </div>
      ),
      width: '116px',
      minWidth: '116px',
      sortType: 'position',

      Cell: ({ ...props }) => {
        const position = props.data[props.row.index]?.position || 1;

        const positionStyle = {
          icon: <Rank1Icon />,
          color: '#D66813',
        };

        switch (position) {
          case 1:
            positionStyle.color = '#D66813';
            positionStyle.icon = <Rank1Icon />;
            break;

          case 2:
            positionStyle.color = '#808080';
            positionStyle.icon = <Rank2Icon />;
            break;

          default:
            positionStyle.color = '#9D3E03';
            positionStyle.icon = <Rank3Icon />;
        }

        return (
          <div
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              style={{
                position: 'absolute',
                color: positionStyle.color,
                fontWeight: 700,
                fontSize: 16,
                lineHeight: '22px',
              }}
            >
              {position}
            </Typography>
            {positionStyle.icon}
          </div>
        );
      },
    },
    {
      id: 'thumbsup',
      Header: 'Thumbs up',
      width: '144px',
      minWidth: '144px',
      sortType: 'thumbsup',
      Cell: ({ ...props }) => {
        const thumbUp = props.data[props.row.index]?.thumbUp || 0;

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 6,
              padding: '12px 42px 12px 8px',
            }}
          >
            <Typography>{thumbUp}</Typography>
            <ThumbUpIcon />
          </div>
        );
      },
    },
    {
      id: 'status',
      Header: 'Status',
      width: '103px',
      minWidth: '103px',
      sort: true,
      sortType: 'status',
      Cell: ({ ...props }) => {
        const isActive = props.data[props.row.index]?.isActive;

        return <StatusTag isActive={isActive} />;
      },
    },
  );

  // if (!isBiologicAdmin) {
  columns.push({
    id: 'action',
    Header: '',
    width: '40px',
    minWidth: '40px',
    sort: false,
    sortType: 'action',
    Cell: ({ ...props }) => {
      const trainerId = props.data[props.row.index]?.id;

      const isActive = props.data[props.row.index]?.isActive;

      return (
        <ButtonIconAction
          actions={[
            // {
            //   label: 'Edit',
            //   onClick: () => onClickAction('edit', trainerId),
            // },
            {
              label: 'Delete',
              onClick: () => onClickAction('delete', trainerId),
            },
            isActive
              ? {
                  label: 'Inactivate',
                  onClick: () => onClickAction('update-status', trainerId),
                }
              : {
                  label: 'Activate',
                  onClick: () => onClickAction('update-status', trainerId),
                },
          ]}
        />
      );
    },
  });
  // }

  return columns;
};
